(function () {
  function setActiveGalleryImage(button) {
    var target = document.querySelector(button.getAttribute('data-gallery-target'));
    if (!target) return;
    var image = button.querySelector('img');
    if (!image) return;
    target.src = button.getAttribute('data-full-src') || image.src;
    target.alt = image.alt;
    var buttons = button.parentElement.querySelectorAll('[data-gallery-target]');
    buttons.forEach(function (item) {
      item.classList.toggle('is-active', item === button);
    });
  }

  document.addEventListener('click', function (event) {
    var galleryButton = event.target.closest('[data-gallery-target]');
    if (galleryButton) {
      setActiveGalleryImage(galleryButton);
    }

    var accordionButton = event.target.closest('[data-accordion-button]');
    if (accordionButton) {
      var item = accordionButton.closest('[data-accordion-item]');
      if (!item) return;
      item.classList.toggle('is-open');
    }

    var waFloat = event.target.closest('[data-wa-float]');
    if (waFloat) {
      if (typeof fbq === 'function') {
        fbq('track', 'Contact');
      }
    }
  });
})();
